export const StreamTypes = Object.freeze({
  /**
   * A live stream is content that is being broadcasted in real-time.
   */
  Live: 'live',

  /**
   * A VOD, or Video on Demand, is pre-recorded content, typically of a past broadcast.
   */
  Vod: 'vod'
})

export const VideoPlayerStates = Object.freeze({
  /**
   * The player is loading more video data and playback is paused.
   *
   * Buffering is the act of preloading content onto the device's memory, temporarily, to allow
   * for smoother playback.
   */
  Buffering: 3,

  /**
   * The video has finished playing.
   */
  Ended: 0,

  /**
   * The video is currently paused.
   */
  Paused: 2,

  /**
   * The video is currently playing.
   */
  Playing: 1,

  /**
   * The video is ready to play but waiting for user, or programmatic, interaction.
   */
  Queued: 5,

  /**
   * The player has loaded the video but playback has not begun.
   */
  Unstarted: -1
})
